export const generateTabMenuKey = (
  spaceId: string | number,
  spaceTabId: string | number,
) => [spaceId, spaceTabId].join('_');
